import { type Control, useFormState, useWatch } from 'react-hook-form';
import { Stack, Grid, Typography, Divider, Box } from '@mui/material';
import WindowIcon from '@mui/icons-material/Window';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';

import { isNil } from '#packages/data-collection/libs/lodash';

export type WindowTypesDetailsProps = {
  control: Control<EditAuditFormBackgroundData>;
};

export const WindowTypesDetails = ({ control }: WindowTypesDetailsProps) => {
  const { errors } = useFormState({ control });

  const { envelope } = useWatch({ control });
  const windowTypes = envelope?.windowTypes;

  const attachmentCount = windowTypes?.attachments?.length ?? 0;

  const items = [
    {
      label: 'Material',
      value: windowTypes?.material,
      error: !!errors.envelope?.windowTypes?.material,
    },
    {
      label: 'No. of panes',
      value: isNil(windowTypes?.numberOfPanes)
        ? undefined
        : String(windowTypes.numberOfPanes),
      error: !!errors.envelope?.windowTypes?.numberOfPanes,
    },
    {
      label: 'Attachments',
      value: attachmentCount > 0 ? String(attachmentCount) : undefined,
      error: false,
    },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1}>
        <Typography
          component="div"
          variant="body2"
          color="textSecondary"
          sx={{ mb: 0.5 }}>
          <Grid container alignItems="center">
            <WindowIcon fontSize="inherit" />
            <span>&nbsp;Window types</span>
          </Grid>
        </Typography>
        {items.map(({ label, value, error }) => (
          <Grid key={label} container justifyContent="space-between">
            <Typography component="span" variant="body2">
              {label}:
            </Typography>
            <Typography
              component="span"
              variant="body2"
              color={
                error ? 'error' : isNil(value) ? 'textDisabled' : 'textPrimary'
              }>
              {isNil(value) ? '—' : value}
            </Typography>
          </Grid>
        ))}
        <Divider />
      </Stack>
    </Box>
  );
};
